import { render, staticRenderFns } from "./moveDownImg.vue?vue&type=template&id=265fee51&"
import script from "./moveDownImg.vue?vue&type=script&lang=js&"
export * from "./moveDownImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports